import React from 'react'
import { Typewriter } from 'react-simple-typewriter'

function Final() {

    return (
        //This will be the final text i.e. the text in Green
    <p>
        <Typewriter words={['And it was really Great!!!']}/>
    </p>
  )
}

export default Final